<template>
  <div class="vote-list-page">
    <p v-if="showNone">
      暂无活动。
    </p>
    <div class="vote-list"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <div v-for="item in activityList" :key="item.id" class="list-item">
        <router-link :to="`/activitydetail/${item.id}`">
          <div class="title">{{ item.title }}</div>
          <div class="desc">
            <ul>
              <li>报名范围：{{ item.projectName }}</li>
              <li>结束时间：{{ item.deadlineTime | formatDate}}</li>
            </ul>
          </div>
          <div class="meta-info">
            <div class="join-info">已有 {{ item.currentNumber }} 人报名</div>
            <div v-if="parseInt(item.activityStatus) === 0" class="btn-state btn-isfinished">已结束</div>
            <div v-else class="btn-state">进行中</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchActivityList } from '../api/api.js'

export default {
  data () {
    return {
      curPage: 0,
      loading: false,
      activityList: [],
      showNone: false
    }
  },
  //时间戳转换
  filters: {
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    }
  },
  methods: {
    async loadMore () {
      this.$indicator.open()
      this.curPage++
      this.showNone = false
      try {
        const res = await fetchActivityList(this.$store.state.userRoles, this.curPage)
        const list = res.data
        if (list.length > 0) {
          this.activityList = this.activityList.concat(list)
        } else {
          // 如果获取为空数组，说明没有这一页的数据了，页码恢复至上一页
          this.curPage--
        }
      } catch (err) {
        // 恢复到上一页的页码，因为当前页未加载成功
        this.curPage--
      }
      // 如果首次加载就为空，说明没有数据
      if (this.curPage === 0) {
        this.showNone = true
      }
      this.$indicator.close()
    }
  }
}
</script>

<style scoped>
  .vote-list-page {
    background: #fff;
    min-height: 100vh;
    text-align: left;
  }

  .vote-list {
    padding: 15px;
  }

  .list-item {
    border: 1px solid #F1C40F;
    border-radius: 5px;
    margin-bottom: 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }

  .list-item a {
    display: block;
    color: inherit;
    text-decoration: none;
  }

  .title {
    height: 32px;
    line-height: 32px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid #F1C40F;
  }

  .desc {
    font-size: 14px;
    padding: 10px;
    line-height: 2;
    color: #666;
  }

  .desc ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .meta-info {
    background: #F1C40F;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    font-size: 14px;
    color: #666;
    padding: 0 15px;
  }

  .btn-state {
    width: 60px;
    text-align: center;
    background: orange;
    color: #fff;
    border-radius: 5px;
    font-size: 12px;
    padding: 3px 0;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  }

  .btn-isfinished {
    background: #999;
    box-shadow: none;
  }
</style>
